import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jracloud-94147_hot-116492_fix_attachments_preview');
	},
};
